import axios from 'axios'
import helper from '../helper'

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL

export const serviceGTM = {
  get: (token) => helper.get('api/v1/google-tag-manager', token),
  getQR: (qrcodeId) => helper.get('api/v1/google-tag-manager/' + qrcodeId),
  create: (token, data) => helper.post('api/v1/google-tag-manager', data, token),
  delete: (token) =>
    axios.delete(apiBaseUrl + 'api/v1/google-tag-manager', {
      headers: {
        Authorization: 'Bearer ' + token
      }
    }).catch(err => err.response)
}
